import { Component, computed, signal, Type } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';

// Registries
import { getCmsComponent } from '@core/registries/cms.registry';

/**
 * Page publique CMS — affiche les sections via NgComponentOutlet.
 * La session est chargée en amont par App avant que le router-outlet soit affiché.
 */
@Component({
	selector: 'page-cms',
	imports: [NgComponentOutlet],
	templateUrl: './cms.html',
	styleUrl: './cms.scss',
})
export class CmsPage {
	readonly sections = signal([{ xtype: 'cms-header-navbar' }, { xtype: 'cms-hero-rounded' }]);

	readonly resolvedSections = computed(() =>
		this.sections()
			.map((s) => ({ ...s, component: getCmsComponent(s.xtype) }))
			.filter((s): s is { xtype: string; component: Type<unknown> } => !!s.component),
	);
}
